module.exports = __webpack_public_path__ + "img/rs_logo.80932999.png";